import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import Employee from '../model/product/employee';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeChoicesService {
  private designerChoices = new ReplaySubject<Employee[]>(1);
  private printworkHandlerChoices = new ReplaySubject<Employee[]>(1);
  private finisherChoices = new ReplaySubject<Employee[]>(1);
  private placerChoices = new ReplaySubject<Employee[]>(1);
  private externalSupplierChoices = new ReplaySubject<Employee[]>(1);
  private quotationHandlerChoices = new ReplaySubject<Employee[]>(1);
  private immoAdminChoices = new ReplaySubject<Employee[]>(1);

  constructor(private requestService: RequestService) {}

  public updateEmployeeChoices() {
    this.getDesignerEmployees();
    this.getPrintworkEmployees();
    this.getFinisherEmployees();
    this.getPlacerEmployees();
    this.getExternalSupplierEmployees();
    this.getQuotationHandlerEmployees();
    this.getImmoAdminEmployees();
  }

  public updateDesignerEmployees() {
    this.getDesignerEmployees();
  }

  public updatePlacerChoices() {
    this.getPlacerEmployees();
  }

  public updateExternalSupplierChoices() {
    this.getExternalSupplierEmployees();
  }

  public updateImmoAdminChoices() {
    this.getImmoAdminEmployees();
  }

  public getDesignerChoicesSubscribable(): Observable<Employee[]> {
    return this.designerChoices;
  }

  public getPrintworkHandlerChoicesSubscribable(): Observable<Employee[]> {
    return this.printworkHandlerChoices;
  }

  public getFinisherChoicesSubscribable(): Observable<Employee[]> {
    return this.finisherChoices;
  }

  public getPlacerChoicesSubscribable(): Observable<Employee[]> {
    return this.placerChoices;
  }

  public getExternalSupplierChoicesSubscribable(): Observable<Employee[]> {
    return this.externalSupplierChoices;
  }

  public getQuotationHandlerChoicesSubscribable(): Observable<Employee[]> {
    return this.quotationHandlerChoices;
  }

  public getImmoAdminChoicesSubscribable(): Observable<Employee[]> {
    return this.immoAdminChoices;
  }

  private getDesignerEmployees(): void {
    this.requestService
      .get('/employees/withType/DESIGNER')
      .toPromise()
      .then(res => {
        this.designerChoices.next(res.body);
      });
  }

  private getPrintworkEmployees(): void {
    this.requestService
      .get('/employees/withType/PRINTER')
      .toPromise()
      .then(res => {
        this.printworkHandlerChoices.next(res.body);
      });
  }

  private getFinisherEmployees(): void {
    this.requestService
      .get('/employees/withType/FINISHER')
      .toPromise()
      .then(res => {
        this.finisherChoices.next(res.body);
      });
  }

  private getPlacerEmployees(): void {
    this.requestService
      .get('/employees/withType/PLACER')
      .toPromise()
      .then(res => {
        this.placerChoices.next(res.body);
      });
  }

  private getExternalSupplierEmployees(): void {
    this.requestService
      .get('/employees/withType/EXTERNAL_SUPPLIER')
      .toPromise()
      .then(res => {
        this.externalSupplierChoices.next(res.body);
      });
  }

  private getQuotationHandlerEmployees(): void {
    this.requestService
      .get('/employees/withType/QUOTATION')
      .toPromise()
      .then(res => {
        this.quotationHandlerChoices.next(res.body);
      });
  }

  private getImmoAdminEmployees(): void {
    this.requestService
      .get('/employees/withType/IMMO_ADMIN')
      .toPromise()
      .then(res => {
        this.immoAdminChoices.next(res.body);
      });
  }
}
